import React from "react";
import { Modal } from "react-bootstrap";
import { formatAmount, formatDate, formatStatus } from "../../../../util/Helpers";
import { GiftCardIcon } from "../../../../util/Icons";

const ViewGiftCardModal = ({ showViewGiftCardModal, details, onHide }) => {

    return (
        <Modal
            show={showViewGiftCardModal}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >

            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <GiftCardIcon />
                    </span>
                    Gift Card Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <div className="row">
                    <div className="col-3 py-4">
                        <h6>QR Code</h6>
                        <img src={`data:image/png;base64, ${details?.qrCode}`} alt="QR Code" />
                    </div>
                    <div className="col-9">
                        <div className="row">
                            <div className="col-lg py-4">
                                <h6>Vendor</h6>
                                <span className="text-muted">{details?.vendor}</span>
                            </div>
                            <div className="col-lg py-4">
                                <h6>Redemption Code</h6>
                                <span className="text-muted">{details?.redemptionCode}</span>
                            </div>
                            <div className="col-lg py-4">
                                <h6>Status</h6>
                                {formatStatus(details?.status)}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg py-4">
                                <h6>Description</h6>
                                <span className="text-muted">{details?.description}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>ID</h6>
                        <span className="text-muted">{details?.id}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Instrument ID</h6>
                        <span className="text-muted">{details?.instrumentId}</span>
                    </div>
                    <div className="col-lg-4 py-4">
                        <h6>User ID</h6>
                        <span className="text-muted">{details?.userId}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Ref ID</h6>
                        <span className="text-muted">{details?.refid}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Account ID</h6>
                        <span className="text-muted">{details?.accountId}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Acount History ID</h6>
                        <span className="text-muted">{details?.accountHistoryId}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 py-4">
                        <h6>Symbol</h6>
                        <span className="text-muted">{details?.asset?.symbol}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Order ID</h6>
                        <span className="text-muted">{details?.depositRetries}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Order Retries</h6>
                        <span className="text-muted">{details?.orderRetries}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Amount</h6>
                        <span className="text-muted">{formatAmount(details?.currency, details?.amount)}</span>
                    </div>
                    <div className="col-lg-4 py-4">
                        <h6>Deposit Retries</h6>
                        <span
                            className="text-muted">{details?.depositRetries}</span>
                    </div>
                    <div className="col-lg-4 py-4">
                        <h6>Status Comment</h6>
                        <span className="text-muted">{details?.statusComment}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Created At</h6>
                        <span className="text-muted">{formatDate(details?.createdAt)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Updated At</h6>
                        <span className="text-muted">{formatDate(details?.updatedAt)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg">
                        <h4 className="mb-4 mt-5 text-muted h5">More Details</h4>
                        <div className="text-muted bg-light-secondary rounded-lg p-4 overflow-auto" style={{ maxHeight: "300px" }}>
                            <pre className="mb-0">{JSON.stringify(details?.meta, null, 4)}</pre>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-4"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>

    );
}

export default ViewGiftCardModal;